import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useGetMenu } from "./hooks/useHome";
import "./styles.scss";
import { useConfigureFooter } from "~hooks/useHelpers";
import { ApoioVendMais, Telefones, VendMais, VotorantimLogo } from "~misc/png_logos";
import PdfApoio from "../../misc/imgs/documentacao_de_apoio_vendMais.pdf";
import PdfGuiaProduto from "../../misc/imgs/guia_produtos.pdf";
import useLogAcessoManual from "~fetchs/useLogAcessoManual";
import ModalImage from "~components/Modal/ModalImage";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import {
  LoadPositionIcon,
  SelfServiceIcon,
  IconReport,
  IconSalesForce,
  IconCreditCard,
  IconTools,
} from "~misc/icons";
import { initialPath } from "~misc/paths";
import useUsuario from "~/fetchs/useUsuario";
import { AcessosSlug } from "~services/GlobalServices";
import { podeEscolherFonte } from "~/pages/SalesManagement/utils/dataSource";


const SalesManagement = () => {

  const {
    isModalOpen,
    closeModal,
    openModal,
  } = useModalResponse();

  const [dataSource, setDataSource] = useState(() =>
    localStorage.getItem('sm_data_source') ?? 'mock'
  );

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  const handleSelectSource = (source) => {
    if (source === dataSource) {
      closeModal();
      return;
    }
    localStorage.setItem('sm_data_source', source);
    closeModal();
    window.location.reload();
  };

  const data = useGetMenu();
  useConfigureFooter({ notDeveloped: false });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { logarAcesso } = useLogAcessoManual();
  const handleClick = (pathname) => {
    logarAcesso(pathname);
  };

  const { usuario } = useUsuario();
  const temAcesso = (slug) => AcessosSlug(usuario?.slugAcessos, slug);






  return (
    <>
      <div className="flex items-center justify-center py-5 max-w-6xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 tb:grid-cols-4 xl:grid-cols-5 gap-[2rem] justify-center">


          {temAcesso("acesso-ao-menu-de-posicao-de-carga") && (
          <Link to={`${initialPath}/gestao-de-vendas/posicao-de-carga`} onClick={() => handleClick("posicao-de-carga")}>
            <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <LoadPositionIcon />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Posição de Carga</h2>
              </div>
            </div>
          </Link>
          )}

          {temAcesso("acesso-ao-menu-de-autosservico") && (
          <Link to={`${initialPath}/gestao-de-vendas/autosservico`} onClick={() => handleClick("autosservico")}>
            <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <SelfServiceIcon />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Autosserviço</h2>
              </div>
            </div>
          </Link>
          )}

          {temAcesso("acesso-ao-menu-de-relatorio-de-vendas") && (
          <Link to={`${initialPath}/gestao-de-vendas/relatorio-de-vendas/carteira`} onClick={() => handleClick("relatorio-de-vendas")}>
            <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <IconReport />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Relatório de Vendas</h2>
              </div>
            </div>
          </Link>
          )}

          {temAcesso("acesso-ao-menu-de-sales-force") && (
          <Link to={`${initialPath}/gestao-de-vendas/sales-force`} onClick={() => handleClick("sales-force")}>
            <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <IconSalesForce />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Eficiência de Vendas</h2>
              </div>
            </div>
          </Link>
          )}

          {temAcesso("acesso-ao-menu-de-credito-de-clientes") && (
          <Link to={`${initialPath}/gestao-de-vendas/credito-de-clientes`} onClick={() => handleClick("credito-de-clientes")}>
            <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <IconCreditCard />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Crédito de Clientes</h2>
              </div>
            </div>
          </Link>
          )}

          {temAcesso("acesso-ao-menu-de-bateu-levou") && (
          <Link to={`${initialPath}/gestao-de-vendas/bateu-levou`} onClick={() => handleClick("ferramentas")}>
            <div className="bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center">
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <IconTools />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Ferramentas</h2>
              </div>
            </div>
          </Link>
          )}





        </div>
      </div>

      {podeEscolherFonte(usuario) && isOnline && (
        <>
          <button
            type="button"
            onClick={openModal}
            className="fixed bottom-6 right-6 z-[1000] flex items-center gap-2 bg-[#01054C] text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg hover:bg-[#0a1a7a] transition"
          >
            <span
              className={`w-2 h-2 rounded-full ${
                dataSource === 'api' ? 'bg-green-400' : 'bg-yellow-400'
              }`}
            />
            Fonte: {dataSource === 'api' ? 'API / Dexie' : 'Mock'}
          </button>

          <ModalImage isOpen={isModalOpen} closeModal={closeModal}>
            <h3 className="text-xl font-bold text-[#01054C] mb-2">Fonte de Dados (QA)</h3>
            <p className="text-sm  mb-6">
              Selecione de onde os dados do módulo de Gestão de Vendas serão carregados.
            </p>
            <div className="flex flex-col gap-3">
              <button
                type="button"
                onClick={() => handleSelectSource('mock')}
                className={`w-full py-3 rounded-lg font-semibold border-2 transition ${
                  dataSource === 'mock'
                    ? 'border-[#01054C] bg-[#01054C] text-white'
                    : 'border-[#01054C] text-[#01054C] hover:border-[#01054C]'
                }`}
              >
                Mock
              </button>
              <button
                type="button"
                onClick={() => handleSelectSource('api')}
                className={`w-full py-3 rounded-lg font-semibold border-2 transition ${
                  dataSource === 'api'
                    ? 'border-none bg-[#01054C] text-white'
                    : 'border-gray-300 text-gray-700 hover:border-green-600'
                }`}
              >
                API / Dexie
              </button>
            </div>
          </ModalImage>
        </>
      )}
    </>
  );
};

export default SalesManagement;
